import { Component, Input, OnInit, OnChanges } from "@angular/core";
import { Title } from "@angular/platform-browser";

import * as _ from "lodash";

@Component({
  selector: "rank-table",
  templateUrl: "./rank-table.component.html",
  styleUrls: ["./rank-table.component.scss"],
})
export class RankTableComponent implements OnInit, OnChanges {
  @Input()
  chartData;
  @Input()
  sortOrder;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  isRestrictedUser;

  sortedList;
  truncatedList;

  constructor(private titleService: Title) {}

  ngOnInit() {
    this.sortedList = this.sortList(this.chartData, this.sortOrder);
    this.truncatedList = _.take(this.sortedList, 5);
  }

  ngOnChanges(changes) {
    this.sortedList = this.sortList(
      this.chartData,
      changes.sortOrder.currentValue
    );
    this.truncatedList = _.take(this.sortedList, 5);
  }

  sortList(list, order) {
    if (order === "highest 5") {
      return (this.sortedList = _.sortBy(list, "y").reverse());
    } else if (order === "lowest 5") {
      return (this.sortedList = _.sortBy(list, "y"));
    }
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
